import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

/**
 * Displays Links that has only Icons but connects to React Router.
 *
 * @param props - details from component and environment API props
 * @returns {*} HTML content.
 */

const RouterSymbol = (props) => {
    const {
        details: {
            name,
            className,
            textClassname,
            linkClassName,
            additionalProperties,
            symbols,
            path,
            urlReplacements,
            text,
            showUnreadMessage
        },
        environment: {
            unreadMessageCount
        },
        index,
        replacements
    } = props;

    const url = urlReplacements ? path.processReplacements(urlReplacements) : path.processReplacements(replacements);

    return (
        <Fragment>
            {
                <li className={className} data-automation-id={name}>
                    <Fragment>
                        {
                            additionalProperties ?
                                <Link
                                    to={url}
                                    className={linkClassName}
                                    target= {additionalProperties.target}
                                    rel= {additionalProperties.rel}
                                    id={name + '_' + index}
                                    text={text}
                                    data-automation-id={name + '_' + index}
                                >
                                    <span key={`${name + '_' + index}`} className={textClassname}>
                                        <FormattedMessage id={text} />
                                    </span>
                                    {
                                        symbols.map(symbol => (
                                            <FontAwesomeIcon key={symbol} className={symbol} icon={symbol} />))}
                                    {
                                        showUnreadMessage && unreadMessageCount > 0 ? <span key={unreadMessageCount + 1} className="unreadRecords">{unreadMessageCount}</span> :
                                            showUnreadMessage && unreadMessageCount <= 0 ? <span key={unreadMessageCount + 1} className="unreadRecords hide"></span> : null
                                    }
                                </Link>

                                :

                                <Link
                                    to={url}
                                    className={linkClassName}
                                    id={name + '_' + index}
                                    data-automation-id={name + '_' + index}
                                >
                                    <span key={`${name + '_' + index}`} className={textClassname}>
                                        <FormattedMessage id={text} />
                                    </span>
                                    {
                                        symbols.map(symbol => (
                                            <FontAwesomeIcon key={symbol} className={symbol} icon={symbol} />))}
                                    {
                                        showUnreadMessage && unreadMessageCount > 0 ? <span key={unreadMessageCount + 1} className="unreadRecords">{unreadMessageCount}</span> :
                                            showUnreadMessage && unreadMessageCount <= 0 ? <span key={unreadMessageCount + 1} className="unreadRecords hide"></span> : null
                                    }
                                </Link>
                        }
                    </Fragment>
                </li>
            }
        </Fragment>
    );
};

export default RouterSymbol;